var globalCountry = "china";
var globalCountryLink = "www.baidu.com";

// 公共参数对象
var PUBLICDATA = {
  globalCountry: "china",
  globalCountryLink: "www.baidu.com",
  globalipData: {
    userIp: "",
    locationInfo: "",
  },
};

// 创建自定义Cookie
// 设置一个名为myCustomCookie的自定义Cookie，有效期为30天,不需要时间的话  则只传两个参数
// setCookie('myCustomCookie3', 'valueExample', 30);
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  const rootDomain = getRootDomain();
  document.cookie =
    name +
    "=" +
    (value || "") +
    expires +
    "; domain=" +
    rootDomain +
    "; path=/";
}

// 读取Cookie --var cookieValue = getCookie('myCustomCookie3');
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

// 使用该函数来清除名为 "myCookie" 的cookie
// deleteCookieByName("PreferredCountry");
function deleteCookieByName(name) {
  // 设置过期时间为过去的时间，这会让浏览器认为该cookie已经过期
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}

function getRootDomain(url) {
  let domain = null;
  // 如果没有传入URL，则使用当前页面的URL
  if (!url) {
    url = window.location.href;
  }
  // 使用正则表达式匹配域名
  const regex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/g;
  const matches = regex.exec(url);
  if (matches && matches[1]) {
    // 提取顶级域名及其上层
    const domainParts = matches[1].split(".").reverse();
    // debugger
    for (let i = 0; i < domainParts.length; i++) {
      if (i > 1) {
        // 跳过 "com", "co.uk", 等顶级域名
        break;
      }
      if (i == 0) {
        domain = domainParts[i];
      } else {
        domain = domainParts[i] + "." + domain;
      }
    }
    // domain = domain.trim().replace(/^\./, ''); // 去除开头的点
  }
  return domain;
}

function getRootDomainNext(url) {
  const parsedUrl = new URL(url);
  const hostname = parsedUrl.hostname; // e.g., "us.hoverair.com"

  // Split the hostname into parts
  const parts = hostname.split(".");

  // The root domain is typically the last two parts (for gTLDs like .com, .org)
  // However, we need to handle special cases, such as subdomains in ccTLDs (e.g., .co.uk)

  // If the hostname has only two parts, it's a simple case (e.g., "example.com")
  if (parts.length === 2) {
    return parts.join(".");
  }

  // For more complex cases, we need to check if the TLD is a two-letter country code (ccTLD)
  // or if there's a subdomain, we assume at least three parts for a generic TLD (gTLD)
  if (parts[0].length === 2 && parts[1].length === 2) {
    // ccTLD (e.g., "co.uk")
    return parts.slice(-2).join(".");
  } else if (parts.length > 2 && parts[1] !== "co") {
    // gTLD with subdomain (e.g., "sub.example.com")
    return parts.slice(-2).join(".");
  } else {
    // gTLD without subdomain (e.g., "example.com")
    return parts[parts.length - 2] + "." + parts[parts.length - 1];
  }
}
// const rootDomain = getRootDomainNext(window.location.href);
// console.log('Root Domain:', rootDomain);

// 获取当前页面url的域名
function getDomain() {
  const url = new URL(window.location.href);
  const domain = url.hostname;
  return domain;

  // hoverair.com  & us.hoverair.com
}
// console.log(getDomain());

// 一次请求获取 IP + 国家/地区信息（api.ip.sb/geoip 本身已返回地理数据，无需二次调用）
async function getUserGeoData() {
  const response = await fetch("https://api.ip.sb/geoip");
  const data = await response.json();
  return {
    ip: data.ip,
    country: data.country,
    region: data.region,
    city: data.city,
  };
}

// 保留旧函数签名以兼容可能存在的其他调用方
async function getCurrentUserIp() {
  const data = await getUserGeoData();
  return data.ip;
}

async function getUserCountryByIp() {
  const data = await getUserGeoData();
  return { country: data.country, region: data.region, city: data.city };
}
